import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { TrophyDetailComponent } from './trophy-detail/trophy-detail.component';

@Component({
  selector: 'vex-thropies-user',
  templateUrl: './thropies-user.component.html',
  styleUrls: ['./thropies-user.component.scss']
})
export class ThropiesUserComponent implements OnInit {
  thropies;
  thropiesPlaceholder = Array(12);
  groupedThropies;

  constructor(
    private dialog: MatDialog,
    private restService: RestService,
    public guiService: GuiService,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    if(!this.guiService.userLogged){
      this.guiService.goTo('main/home');
    }
    this.getThropies();
  }

  openModalTrophyDetail(trophy: any): void {
    this.dialog.open(TrophyDetailComponent, {
      disableClose: true,
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      autoFocus: false,
      panelClass: 'full-screen-dialog',
      data: { trophy }
    });
  }


  getThropies() {
    console.debug(this.guiService.userLogged)
    this.restService
      .postService("node", "/get-user-thropies", {
        userId: this.guiService.userLogged.user.id
      })
      .subscribe((ris) => {
        console.debug("thropies", ris);
        this.thropies = ris;
        this.groupedThropies = this.groupByCategory(this.thropies);
        console.debug(this.groupedThropies);
      });
  }

  getCompletedThropiesNumber() {
    return this.thropies.filter((x) => x.unlocked === true).length;
  }

  groupByCategory(thropies: any[]) {
    const grouped: { [key: string]: any[] } = {};

    for (const thropy of thropies) {
      const category = thropy.type;
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(thropy);
    }

    const fixedOrder = [
      "workout",
      "consistency",
      "programs",
      "challenges",
      "fullWeeks",
      "workoutInWeeks",
    ];

    return fixedOrder
      .filter((category) => grouped[category] && grouped[category].length > 0) // filtra solo categorie non vuote
      .map((category) => ({
        key: category,
        value: grouped[category],
      }));
  }
}

